module.exports = __webpack_public_path__ + "img/sti-dest-sc-active.d03a11d7.svg";